'use client';

import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './Container.module.scss';

/**
 * ##Import
 * `import Container from "components/atoms/Grid/Container/Container";`
 */

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  fullWidth?: boolean;
  isFluid?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ fullWidth, isFluid = false, children, className, ...props }, ref) => {
    return (
      <div
        className={classnames(
          styles.container,
          {
            [styles.fullWidth]: fullWidth,
            [styles.fixedWidth]: !isFluid,
            [styles.isFluid]: isFluid,
          },
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';

export default Container;
